import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import aacsbLogo from "../assets/img/rec/aacsb.png"

export default function AccreditationAacsb() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* HERO */}
                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute right-0 top-0 h-full w-[48%] bg-[linear-gradient(135deg,#0C2744_0%,#071A2F_100%)]" />
                        <div className="absolute right-[10%] top-[80px] h-[500px] w-px rotate-[24deg] bg-white/10" />
                        <div className="absolute right-[22%] top-[80px] h-[500px] w-px rotate-[24deg] bg-[#D5AD57]/15" />
                        <div className="absolute right-[34%] top-[80px] h-[500px] w-px rotate-[24deg] bg-white/10" />
                        <div className="absolute bottom-0 left-0 h-[5px] w-[30%] bg-[#8B1E3F]" />
                        <div className="absolute bottom-0 left-[30%] h-[5px] w-[15%] bg-[#D5AD57]" />
                    </div>


                    <div className="relative mx-auto grid min-h-[620px] w-[min(1380px,calc(100%-48px))] items-center gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.05fr_.95fr]">

                        {/* LEFT */}
                        <div className="">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                AACSB Member
                            </div>


                            <h1 className="mt-7 max-w-[830px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6vw,88px)] font-normal leading-[0.95] tracking-[-0.045em]">
                                Connected to the
                                <span className="block text-[#D5AD57]">
                                    global business education community.
                                </span>
                            </h1>


                            <p className="mt-8 max-w-[700px] text-[17px] leading-8 text-white/65">
                                AACSB membership connects ISBM University with a global community focused on business education, academic development and institutional engagement.
                            </p>


                            <div className="mt-10 flex gap-5">

                                <span className="border border-[#D5AD57]/30 px-5 py-3 text-[9px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                    Business Education
                                </span>

                                <span className="border border-white/15 px-5 py-3 text-[9px] font-bold uppercase tracking-[0.15em] text-white/55">
                                    Global Network
                                </span>

                            </div>

                        </div>


                        {/* BUSINESS NETWORK PANEL */}
                        <div className="relative hidden min-h-[500px] lg:block">

                            <div className="absolute right-0 top-1/2 w-[430px] -translate-y-1/2">

                                <div className="bg-white p-5">
                                    <img src={aacsbLogo} alt="AACSB" className="mx-auto max-h-[160px] object-contain" />
                                </div>


                                <div className="grid grid-cols-3 gap-px bg-white/10">

                                    {[
                                        ["01", "Connect"],
                                        ["02", "Learn"],
                                        ["03", "Engage"],
                                    ].map(([number, title]) => (
                                        <div key={number} className="bg-[#8B1E3F] p-5 text-center">

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#D5AD57]">
                                                {number}
                                            </span>

                                            <span className="mt-2 block text-[9px] font-bold uppercase tracking-[0.12em] text-white/60">
                                                {title}
                                            </span>

                                        </div>
                                    ))}

                                </div>


                                <div className="border-t border-white/10 bg-[#0C2744] p-6">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Membership Status
                                    </span>

                                    <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-white">
                                        AACSB Member
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* INTRO */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.7fr_1.3fr] lg:gap-20">

                        <div>

                            <Eyebrow>
                                AACSB Membership
                            </Eyebrow>

                            <Title before="Engaging With a" highlight="Global Business Network" after="" position="middle" theme="burgundy" />

                        </div>


                        <div className="lg:pt-7">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] leading-[1.35] text-[#071A2F]">
                                Membership provides a platform for engagement with developments, conversations and networks within global business education.
                            </p>

                        </div>

                    </div>

                </section>


                {/* VALUE OF MEMBERSHIP */}
                <section className="bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <Eyebrow>Membership Perspective</Eyebrow>

                        <Title before="Strengthening Connections in" highlight="Business Education" after="" position="middle" theme="burgundy" />


                        <div className="mt-14 grid gap-6 lg:grid-cols-[1.3fr_.7fr]">

                            <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                {[
                                    ["01", "Global Engagement", "Connection with a wider community of institutions engaged in business education."],
                                    ["02", "Knowledge Exchange", "Exposure to ideas, practices and discussions relevant to management education."],
                                    ["03", "Institutional Learning", "Opportunities to learn from developments shaping contemporary business schools."],
                                    ["04", "Professional Network", "A platform for academic and institutional engagement within the business education ecosystem."],
                                ].map(([number, title, text]) => (
                                    <article key={number} className="min-h-[260px] bg-white p-7">

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] text-[#D5AD57]">
                                            {number}
                                        </span>

                                        <h3 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#071A2F]">
                                            {title}
                                        </h3>

                                        <p className="mt-4 text-[14px] leading-7 text-[#65727E]">
                                            {text}
                                        </p>

                                    </article>
                                ))}

                            </div>


                            {/* IMPORTANT STATUS PANEL */}
                            <div className="flex flex-col justify-between bg-[#071A2F] p-8 text-white lg:p-10">

                                <div>

                                    <span className="text-[9px] font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                        Important Distinction
                                    </span>

                                    <h3 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] leading-[1.12]">
                                        Membership and accreditation are different statuses.
                                    </h3>

                                </div>


                                <p className="mt-10 text-[14px] leading-7 text-white/55">
                                    This page identifies ISBM University as an AACSB Member. It should not describe the University as AACSB accredited unless accreditation has been formally awarded and confirmed.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}